var IdentityServerModule = /** @class */ (function () {
    function IdentityServerModule() {
    }
    return IdentityServerModule;
}());
export { IdentityServerModule };
